import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Avatar, Divider } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
const drawerWidth = 0;
const EditorLayout = ({ children, data, maxWidth, useStorageUrl }) => {
    let top_bar_menu = undefined;
    let bottom_menu = undefined;
    let top_bar_menu_left_items = undefined;
    let top_bar_menu_right_items = undefined;
    let bottom_menu_left_items = undefined;
    let bottom_menu_right_items = undefined;
    let editorMaxWidth = maxWidth ? maxWidth : 1280;
    let usedStorageUrl = useStorageUrl ? useStorageUrl : false;
    console.log("EDITOR WIDTH: ", editorMaxWidth);
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    function create_menu_item(menu_item, isRight) {
        if (menu_item.right != isRight) {
            return (React.createElement(React.Fragment, null));
        }
        let icon = menu_item.icon;
        if (usedStorageUrl && menu_item.icon_content_hash) {
            icon = menu_item.icon_content_hash;
        }
        return (React.createElement(Button, { href: menu_item.url, target: menu_item.open_in_new_tab ? "_blank" : undefined, color: "inherit", "aria-label": "open drawer", sx: { marginLeft: 'auto' }, startIcon: icon ? React.createElement(Avatar, { src: icon }) : undefined },
            React.createElement(Typography, { variant: "h6", noWrap: true, component: "div" }, menu_item.label)));
    }
    function create_menu_items(menu_items, isRight) {
        let style = !isRight ? { flexGrow: 1, display: 'flex' } : { flexGrow: 1, display: 'flex', justifyContent: 'flex-end' };
        return (React.createElement(Box, { sx: style }, menu_items.map((menu_item, index) => {
            var _a;
            return (React.createElement("div", { key: (_a = menu_item.label) !== null && _a !== void 0 ? _a : index }, create_menu_item(menu_item, isRight)));
        })));
    }
    if (data) {
        if (data.page_layout_data && data.show_menu) {
            if (data.page_layout_data.top_menu) {
                top_bar_menu_left_items = create_menu_items(data.page_layout_data.top_menu.menu_items, false);
                top_bar_menu_right_items = create_menu_items(data.page_layout_data.top_menu.menu_items, true);
                top_bar_menu = (React.createElement(AppBar, { position: "fixed", sx: {
                        width: { sm: '100%' },
                        ml: { sm: '100%' },
                    } },
                    React.createElement(Toolbar, { sx: {
                            margin: "auto",
                            maxWidth: editorMaxWidth,
                            width: "100%"
                        }, disableGutters: true },
                        top_bar_menu_left_items && (React.createElement(React.Fragment, null, top_bar_menu_left_items)),
                        top_bar_menu_right_items && (React.createElement(React.Fragment, null, top_bar_menu_right_items)),
                        React.createElement(Box, { sx: { flexGrow: 1, display: { xs: 'flex', md: 'none' } } },
                            React.createElement(IconButton, { size: "large", "aria-label": "account of current user", "aria-controls": "menu-appbar", "aria-haspopup": "true", onClick: handleOpenNavMenu, color: "inherit" },
                                React.createElement(MenuIcon, null)),
                            React.createElement(Menu, { id: "menu-appbar", anchorEl: anchorElNav, anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }, keepMounted: true, transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                }, open: Boolean(anchorElNav), onClose: handleCloseNavMenu, sx: {
                                    display: { xs: 'block', md: 'none' },
                                } }, data.page_layout_data.top_menu.menu_items.map((menu_item) => (React.createElement(MenuItem, { key: menu_item, onClick: handleCloseNavMenu },
                                React.createElement(Typography, { textAlign: "center" }, menu_item.label)))))))));
            }
            if (data.page_layout_data.bottom_menu) {
                bottom_menu_left_items = create_menu_items(data.page_layout_data.bottom_menu.menu_items, false);
                bottom_menu_right_items = create_menu_items(data.page_layout_data.bottom_menu.menu_items, true);
                bottom_menu = (React.createElement(Box, null,
                    React.createElement(Toolbar, null,
                        bottom_menu_left_items && (React.createElement(React.Fragment, null, bottom_menu_left_items)),
                        bottom_menu_right_items && (React.createElement(React.Fragment, null, bottom_menu_right_items)))));
            }
        }
    }
    return (React.createElement(Box, null,
        React.createElement(CssBaseline, null),
        top_bar_menu && (React.createElement(React.Fragment, null, top_bar_menu)),
        React.createElement(Box, { component: "main", sx: {
                flexGrow: 1,
                margin: 'auto',
                marginTop: '64px',
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                background: (theme) => theme.palette.grey[100],
            } },
            React.createElement(Box, { sx: {
                    flexGrow: 1,
                    backgroundColor: 'white',
                    maxWidth: editorMaxWidth,
                    margin: 'auto',
                } },
                children,
                React.createElement(Divider, null),
                React.createElement("footer", null, bottom_menu && (React.createElement(React.Fragment, null, bottom_menu)))))));
};
export default EditorLayout;
//# sourceMappingURL=EditorLayout.js.map